import { Button, Box, Typography, Container } from "@mui/material";
import MobileStepper from "@mui/material/MobileStepper";
import { theme } from "../styles/theme";
import { LanguageData } from "./LanguageData";
import * as styles from "../styles/WalkthroughScreen.module.scss";

const WalkthroughScreen: React.FC<{
  variant: string;
  title?: string;
  text?: string;
  image?: string;
  steps?: number;
  activeStep?: number;
  handleNextStep: () => void;
  handleSkip: () => void;
  skipText: string;
  buttonText: string;
}> = ({
  variant,
  title,
  text,
  image,
  steps,
  activeStep,
  handleNextStep,
  handleSkip,
  skipText,
  buttonText,
}) => {
  const isLanguageVariant = variant === "language";

  return (
    <Container
      sx={{ backgroundColor: theme.palette.background.default }}
      className={styles.WalkthroughScreen}
    >
      <Box className={styles.skipButtonContainer}>
        <Button
          onClick={handleSkip}
          className={styles.skipButton}
          disableElevation
        >
          <Typography variant="body2">{skipText}</Typography>
        </Button>
      </Box>
      {!isLanguageVariant && (
        <Box className={styles.imageContainer}>
          <img
            src={require(`../assets/welcome-walkthrough/${image}.png`)}
            alt={image}
            className={styles.image}
          />
        </Box>
      )}
      <Box className={styles.contentContainer}>
        {isLanguageVariant ? (
          <LanguageData />
        ) : (
          <>
            {!isLanguageVariant && (
              <MobileStepper
                variant="dots"
                steps={steps}
                position="static"
                activeStep={activeStep}
                nextButton={null}
                backButton={null}
              />
            )}
            <Box className={styles.content}>
              <Typography variant="h4" id="modal-title">
                {title}
              </Typography>
              <Typography variant="body1" color={theme.palette.text.secondary}>
                {text}
              </Typography>
            </Box>
          </>
        )}
      </Box>
      <Box>
        <Button
          color="primary"
          variant="contained"
          disableElevation
          fullWidth
          onClick={handleNextStep}
        >
          {buttonText}
        </Button>
      </Box>
    </Container>
  );
};

export default WalkthroughScreen;
